import cashierStoreMappings from './cashierStoreMappings';
import cashierStores from './cashierStores';

export default {
  cashierStores,
  cashierStoreMappings,
};
